import axios from "axios";
import * as types from "../mutation-types";
import "moment/dist/locale/de";
import moment from "moment/min/moment-with-locales";
import logger from "~/utilities/logger";

// state
export const state = {
  history_list: null,
  history_item: null,
  last_search_query: ["", ""],
  last_min_date: moment().toDate(), //todo
  last_max_date: null,
  needs_history: false,
  last_search_areas: {
    users: 0,
    projects: 1,
  },
};

// getters
export const getters = {
  needs_history: (state) => state.needs_history,
  history_list: (state) => state.history_list,
  history_item: (state) => state.history_item,
  last_search_query: (state) => state.last_search_query,
  last_search_areas: (state) => state.last_search_areas,
  last_min_date: (state) => state.last_min_date,
  last_max_date: (state) => state.last_max_date,
  check_list: (state) => state.history_list !== null,
  check_item: (state) => state.history_item !== null,
  check_last_search: (state) => state.last_search_query.length > 0,
  check_last_min_date: (state) => state.last_min_date !== null,
  check_last_max_date: (state) => state.last_max_date !== null,
};

// mutations
export const mutations = {
  [types.FETCH_HISTORY](state, { history_list })
  {
    state.history_list = history_list;
  },

  [types.FETCH_HISTORY_FAILURE](state)
  {
    logger.error("FETCH_HISTORY_FAILURE");
  },

  [types.SET_LAST_SEARCH_QUERY](state, payload)
  {
    state.last_search_query[payload.area] = payload.query;
  },

  [types.SET_NEEDS_HISTORY](state, status)
  {
    state.needs_history = status;
  },

  [types.CLEAR_LAST_SEARCH_QUERY](state, area)
  {
    state.last_search_query[area] = "";
  },

  [types.SET_LAST_MIN_DATE](state, min_date)
  {
    state.last_min_date = min_date;
  },

  [types.CLEAR_LAST_MIN_DATE](state)
  {
    state.last_min_date = null;
  },

  [types.SET_LAST_MAX_DATE](state, max_date)
  {
    state.last_max_date = max_date;
  },

  [types.CLEAR_LAST_MAX_DATE](state)
  {
    state.last_max_date = null;
  },
};

// actions
export const actions = {
  async setLastSearch({ commit, dispatch }, payload)
  {
    logger.error("store.setLastSearch", payload);
    commit(types.SET_LAST_SEARCH_QUERY, payload);
  },

  async setNeedsHistory({ commit, dispatch }, status = false)
  {
    logger.error("store.setNeedsHistory", status);
    commit(types.SET_NEEDS_HISTORY, status);
  },

  async clearLastSearch({ commit }, area)
  {
    commit(types.CLEAR_LAST_SEARCH_QUERY, area);
  },

  async setLastMinDate({ commit, dispatch }, min_date)
  {
    logger.error("store.setMinDate", min_date);
    commit(types.SET_LAST_MIN_DATE, min_date);
  },

  async clearLastMinDate({ commit })
  {
    logger.error("store.clearLastMinDate");
    commit(types.SET_LAST_MIN_DATE);
  },

  async setLastMaxDate({ commit, dispatch }, max_date)
  {
    logger.error("store.setLastMaxDate", max_date);
    commit(types.SET_LAST_MAX_DATE, max_date);
  },

  async clearLastMaxDate({ commit })
  {
    commit(types.SET_LAST_MAX_DATE);
  },

  async getHistory({ commit, dispatch }, payload)
  {
    if (!payload.uid) return;
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";

    try
    {
      logger.log(
        "store.getHistory",
        `/api/user_states/${payload.uid}?paginate=${paginate}${extraOptions}`
      );
      const { data } = await axios.get(
        `/api/user_states/${payload.uid}?paginate=${paginate}${extraOptions}`
      );
      if (data && data.status && data.status === "success")
      {
        this.history_list = data.data.data;
        commit(types.FETCH_HISTORY, { payload: data.data.data });
      } else
      {
      }
      logger.log("store.getHistory rsp", data);
    } catch (e)
    {
      logger.log(e);
      commit(types.FETCH_HISTORY_FAILURE, { error: e });
    }
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
